import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useHistory } from "react-router-dom";
/**
 * Auth0ProviderWithHistory allows links to resolve properly (on mobile) after login redirection
 * Implementation details was suggested from this guide below
 * https://auth0.com/blog/complete-guide-to-react-user-authentication/#Set-Up-the-Auth0-React-SDK
 */
export default function Auth0ProviderWithHistory({ children, clientId, domain, audience, redirectUri, ...rest }) {
    const history = useHistory();
    function onRedirectCallback(appState) {
        // default to origin path if appstate.returnTo is not provided
        history.replace((appState === null || appState === void 0 ? void 0 : appState.returnTo) || redirectUri || window.location.origin);
    }
    return (React.createElement(Auth0Provider, { clientId: clientId, domain: domain, audience: audience, redirectUri: redirectUri, onRedirectCallback: onRedirectCallback, ...rest }, children));
}
//# sourceMappingURL=index.js.map